export const SupplierContactGetters = {
  GetSupplierContact: 'getSupplierContact'
};
export const SupplierContactMutations = {
  SetSupplierContact: 'setSupplierContact'
};
export const SupplierContactActions = {
  GetSupplierContact: 'getSupplierContact',
  SaveSupplierContact: 'saveSupplierContact'
};
